export class Repertoire {
    constructor() {
        this.setProperties();
        this.setEvents();
    }

    setProperties() {
        this.$cartPageWrapper = $( '.cart-page-wrapper' );
        this.$ticketFrame = $( '#ticket-frame' );
        this.$showCheckoutButton = $( '.show-checkout-button' );

        this.$readMoreDescButton = $( '.read-more-desc-link' );
        this.$eventDesc = $( '#event-desc' );
    }

    setEvents() {
        this.$showCheckoutButton.on( 'click', ( event ) => {
            event.preventDefault();

            this.$cartPageWrapper.addClass( 'show-checkout' );
            $( '#ticket-frame-wrapper' ).get( 0 ).scrollIntoView();
        } );
        this.$readMoreDescButton.on( 'click', ( event ) => {
            event.preventDefault();
            this.$eventDesc.addClass( 'open' );
            this.$readMoreDescButton.remove();
        } );
    }
}
